import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translationen from "./translation/translationen.json";
import translationhindi from "./translation/translationhindi.json";

const resources = {
  en: {
    translation: translationen,
  },
  sg: {
    translation: {
      company: "Company Name (Singapore)",
      email: "Email ID (Singapore)",
      code: "Registration ID (Singapore)",
      address: "Address (Singapore)",
      industryType: "Industry Type (Singapore)",
      password: "Password (Singapore)",
      signUp: "Sign Up (Singapore)",
      privacyPolicy:
        "By clicking the sign-up button, I confirm that I have read, understood and agree to the Terms of the privacy policy (Singapore)",
      servicePolicy:
        "By clicking the sign-up button, I confirm that I have read, understood and agree to the Terms of the Service policy (Singapore)",
      // ... other translations
    },
  },
  // hi: {
  //   translation: translationhindi,
  // },
};
const language = localStorage.getItem("language");
i18next.use(initReactI18next).init({
  resources,
  lng: language || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
